package one.healthium.profile.ui.update_food

import one.healthium.base.utils.divSafe
import one.healthium.domain.common.FoodUnit
import one.healthium.profile.ui.food.models.AmountUiModel
import one.healthium.profile.ui.food.models.FloatPart
import one.healthium.profile.ui.food.models.FoodUiModel
import one.healthium.profile.ui.food.models.FoodUiOptions
import one.healthium.profile.ui.food.models.Units
import one.healthium.profile.ui.food_history.models.FoodItemUiModel
import kotlin.time.Instant

internal data class UpdateFoodUiState(
    val loading: Boolean = false,
    val currentFood: FoodItemUiModel? = null,
    val currentAmount: AmountUiModel? = null,
    val isMetric: Boolean = false,
    val selectedDate: Instant? = null,
) {
    val food = currentFood?.let {
        FoodUiModel(
            emoji = "",
            product = it.name,
            description = "",
            calories = (it.calories * 100).divSafe(it.amount),
            carbohydrates = (it.carbohydrates * 100).divSafe(it.amount),
            fat = (it.fat * 100).divSafe(it.amount),
            fiber = (it.fiber * 100).divSafe(it.amount),
            protein = (it.protein * 100).divSafe(it.amount),
            tablespoon = currentFood.tablespoon,
            cups = currentFood.cups,
            pieces = currentFood.pieces,
            portion = currentFood.portion,
            isLiquid = it.isLiquid,
        )
    }
    val amount: AmountUiModel? = currentAmount ?: currentFood?.let {
        val availableUnits = AmountUiModel.availableUnits(
            isMetric = isMetric,
            tablespoon = it.tablespoon,
            cups = it.cups,
            pieces = it.pieces,
            portion = it.portion,
            isLiquid = it.isLiquid,
        )
        val selectedUnit = currentFood.unit?.toUnit(it)
        val unit = when {
            selectedUnit != null && availableUnits.contains(selectedUnit) -> selectedUnit
            else -> AmountUiModel.defaultUnit(isMetric, it.isLiquid)
        }
        val amountValue = it.amount / unit.gramValue
        AmountUiModel(
            integerPart = amountValue.toInt(),
            floatingPart = FloatPart.valueOf(amountValue),
            unit = unit,
            units = availableUnits
        )
    }

    val options = if (amount != null && food != null && currentFood != null) {
        FoodUiOptions(amount, food, selectedDate ?: currentFood.date)
    } else {
        null
    }
}

private fun FoodUnit.toUnit(foodItemModel: FoodItemUiModel): Units? {
    return when (this) {
        FoodUnit.Gram -> Units.Gram
        FoodUnit.Ml -> Units.Ml
        FoodUnit.Oz -> Units.Oz
        FoodUnit.FlOz -> Units.FlOz
        FoodUnit.Cup -> foodItemModel.cups?.let { Units.Cup(it) }
        FoodUnit.Tablespoon -> foodItemModel.tablespoon?.let { Units.Tablespoon(it) }
        FoodUnit.Teaspoon -> foodItemModel.tablespoon?.let { Units.Teaspoon(it.div(3)) }
        FoodUnit.Piece -> foodItemModel.pieces?.let { Units.Piece(it) }
        FoodUnit.Portion -> foodItemModel.portion?.let { Units.Portion(it) }
    }
}
